<!-- 地图 -->
<style lang="stylus" scoped>
.nav {
  position: fixed;
  bottom:20px;
  z-index:999;
  left:0
  right:0

  .swiper-container {
    width: 500px;
  }
}

.nav-item-bg {
  width: 79px;
  height: 75px;
  margin: 0 auto;
  padding-top: 12px;
  // background: url('../../../../../../assets/img/dashboard/nav-item-bg.png');
  background-size: 100% 100%;
}

.nav-item {
  font-size: 10px;
  color: #fff;
  text-align: center;
  margin-right: 20px;

  i {
    display: inline-block;
    width: 35px;
    height: 32px;
    margin-bottom: 5px;
    // background: url('../../../../../../assets/img/dashboard/nav-icon.png') no-repeat;
  }
}

.nav-item:nth-child(1) i {
  background-position: -2px 0;
}

.nav-item:nth-child(2) i {
  background-position: -120px 0;
}

.nav-item:nth-child(3) i {
  background-position: -235px 0;
}

.nav-item:nth-child(4) i {
  background-position: -355px 0;
}

.nav-item:nth-child(5) i {
  background-position: -473px 0;
}

.nav-item:nth-child(6) i {
  background-position: -588px 0;
}

.nav-item:nth-child(5) i {
  background-position: -710px 0;
}

.nav-item:nth-child(8) i {
  background-position: -826px 0;
}

.nav-item:nth-child(9) i {
  background-position: -949px 0;
}

.nav-item:nth-child(10) i {
  background-position: -1064px 0;
}

.bottom {
  position: absolute;
  bottom: 50px;
  width:731px;
  height: 144px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: url('../../../../../../assets/img/ljc/icon.png');
  background-size: 100% 100%;
}

.swiper-button-next, .swiper-button-prev {
  width: 126px;
  height: 67px;
  top: 15px;
}

.swiper-button-prev {
  background: url('../../../../../../assets/img/dashboard/prev.png');
  background-size: 100% 100%;
}

.swiper-button-next {
  background: url('../../../../../../assets/img/dashboard/next.png');
  background-size: 100% 100%;
}
</style>

<template>
  <div>
    <!-- <div class="nav">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in swiperData" :key="index" class="nav-item">
          <div class="nav-item-bg" @click="clickPage(index)">
            <i></i>
            <p>{{ item }}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div> -->
    <div class="bottom"></div>
  </div>
</template>

<script>
import '../../../../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperData: ['总屏', '销售数据', '基地数据', '溯源数据', '精准扶贫'],
      swiperOption: {
        slidesPerView: 6,
        speed: 300,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  // ['总屏', '销售数据', '基地数据', '溯源数据', '产品展示'],
  methods: {
    clickPage(index) {
      if (index === 0) { // 总屏
        this.$router.push('/rundadashboard');
      } else if (index === 1) { // 销售数据
        this.$router.push('/rundasalesDataCenter');
      } else if (index === 2) { // 基地数据
        this.$router.push('/rundaindustryInformation');
      } else if (index === 3) { // 环境监测
        this.$router.push('/rundatrace');
      } else if (index === 4) { // 溯源数据
        this.$router.push('/rundahelper');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?354d95e6